<div class="row" *ngIf="isFreemium || data?.trafficDistribution?.trafficSources?.length > 0">
  <div class="col-lg-4 col-md-4 leftOverview">
    <ul class="list-group mx-auto" *ngIf="!isFreemium">
      <li class="list-group-item" *ngFor="let trafficData of data?.trafficDistribution?.trafficSources | slice:0:5">
        <h5>
          {{trafficData.trafficSource}}
          <small>
            <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" entooltip=""
              [attr.title]="tooltipData[trafficData.trafficSource]" style="cursor: pointer;"></i>
          </small>
        </h5>
        <h5 class="value">{{trafficData.totalTrafficRatio | perc:'1.2-2'}}</h5>
      </li>
    </ul>
    <ul class="list-group mx-auto" *ngIf="isFreemium">
      <li class="list-group-item">
        <h5>
          Direct
          <small>
            <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" entooltip=""
              [attr.title]="tooltipData['Direct']" style="cursor: pointer;"></i>
          </small>
        </h5>
        <h5 class="value">
          <div class="freemium-lock"><i class="fa fa-lock"></i></div>
        </h5>
      </li>
      <li class="list-group-item">
        <h5>
          Search
          <small>
            <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" entooltip=""
              [attr.title]="tooltipData['Search']" style="cursor: pointer;"></i>
          </small>
        </h5>
        <h5 class="value">
          <div class="freemium-lock"><i class="fa fa-lock"></i></div>
        </h5>
      </li>
      <li class="list-group-item">
        <h5>
          Discovery
          <small>
            <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" entooltip=""
              [attr.title]="tooltipData['Discovery']" style="cursor: pointer;"></i>
          </small>
        </h5>
        <h5 class="value">
          <div class="freemium-lock"><i class="fa fa-lock"></i></div>
        </h5>
      </li>
      <li class="list-group-item">
        <h5>
          Social
          <small>
            <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" entooltip=""
              [attr.title]="tooltipData['Social']" style="cursor: pointer;"></i>
          </small>
        </h5>
        <h5 class="value">
          <div class="freemium-lock"><i class="fa fa-lock"></i></div>
        </h5>
      </li>
      <li class="list-group-item">
        <h5>
          Email
          <small>
            <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" entooltip=""
              [attr.title]="tooltipData['Email']" style="cursor: pointer;"></i>
          </small>
        </h5>
        <h5 class="value">
          <div class="freemium-lock"><i class="fa fa-lock"></i></div>
        </h5>
      </li>
    </ul>
  </div>
  <div class="col-lg-8 col-md-8 chartContainer">
    <ng-container *ngIf="!isFreemium">
      <app-line-chart [data]="lineChartData" [categoryField]="'month'" [valueFields]="['Search', 'Direct', 'Social']"
        [valueAxisUnit]="'%'" [height]="'400px'" [type]="'double'" [titleArray]="['Search', 'Direct', 'Social']">
      </app-line-chart>
    </ng-container>

    <div class="container-fluid" style="min-width: 500px;">
      <div id="accordion" role="tablist" aria-multiselectable="true">
        <div class="row table-header">
          <div class="text-uppercase col-4">
            <strong>SOURCE</strong>
          </div>
          <div class="text-uppercase col">
            <strong>CONTRIB %</strong>
          </div>
          <div class="text-uppercase col">
            <strong>IVT %</strong>
          </div>
          <div class="text-uppercase col">
            <strong>VIEWABILITY %</strong>
          </div>
        </div>
        <div class="row" *ngFor="let trafficData of data?.trafficDistribution?.trafficSources">
          <div class="row-body" *ngIf="trafficData?.pageReferrers?.length > 0">
            <div class="panel-heading" role="tab" [attr.id]="'heading-'+trafficData.trafficSource">
              <div class="container-fluid" style="min-width: 500px;">
                <div class="row">
                  <div class="col-4">
                    <ng-container *ngIf="!isFreemium">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion"
                        [attr.href]="'#'+trafficData.trafficSource" aria-expanded="false"
                        [attr.aria-controls]="trafficData.trafficSource">
                        <small>
                          <i class="fa" data-toggle="collapse" [attr.aria-controls]="trafficData.trafficSource"></i>
                        </small> {{trafficData.trafficSource}}
                      </a>
                    </ng-container>
                    <ng-container *ngIf="isFreemium">
                      {{trafficData.trafficSource}}
                    </ng-container>
                  </div>
                  <div class="text-uppercase text-xs-right col">
                    <ng-container *ngIf="isFreemium">
                      <div class="freemium-lock">
                        <i class="fa fa-lock"></i>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!isFreemium">{{trafficData.totalTrafficRatio | perc:'1.2-2'}}</ng-container>
                  </div>
                  <div class="text-uppercase text-xs-right col">
                    <ng-container *ngIf="isFreemium && !isFollowing">
                      <div class="freemium-lock">
                        <i class="fa fa-lock"></i>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                      {{trafficData.givtSivtRate | perc:'1.2-2'}}
                    </ng-container>
                  </div>
                  <div class="text-uppercase text-xs-right col">{{trafficData.nonGivtSivtViewability | perc:'1.2-2'}}
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="!isFreemium">
              <div [attr.id]="trafficData.trafficSource" class="panel-collapse collapse" role="tabpanel"
                [attr.aria-labelledby]="'heading-'+trafficData.trafficSource">
                <div class="col-lg-12 data-table">
                  <referral-traffic-section [trafficData]="trafficData" [region]="region" [device]="device">
                  </referral-traffic-section>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>